import { DropDownList, DropDownListChangeEvent } from '@progress/kendo-react-dropdowns';
import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { ProductFilterCategories } from 'src/constants/productFilterCategories';
import { DropDownCategories } from 'src/types/generic';
import { useContextSelector } from 'use-context-selector';
import { ShoppingListProductsContext } from './ShoppingListProductsContext';

const ShoppingListItemFilterDropdown = () => {
  const { t } = useTranslation();

  const handleConfirm = useContextSelector(
    ShoppingListProductsContext,
    (context) => context.handleConfirm
  );
  const setDataState = useContextSelector(
    ShoppingListProductsContext,
    (context) => context.setDataState
  );
  const itemFilter = useContextSelector(
    ShoppingListProductsContext,
    (context) => context.itemFilter
  );
  const setItemFilter = useContextSelector(
    ShoppingListProductsContext,
    (context) => context.setItemFilter
  );

  const translatedFilterCategories = useMemo(
    () => ProductFilterCategories.map((cat) => ({ ...cat, label: t(cat.label) })),
    [t]
  );

  const translatedValue = useMemo(
    () =>
      itemFilter
        ? { ...itemFilter, label: t(itemFilter.label) }
        : translatedFilterCategories[0],
    [itemFilter, t, translatedFilterCategories]
  );

  const handleItemFilterChange = useCallback(
    async (e: DropDownListChangeEvent) => {
      const value = e.value as DropDownCategories;

      await handleConfirm(() => {
        setItemFilter(value);
        setDataState((prev) => ({ ...prev, skip: 0 }));
      });
    },
    [handleConfirm, setDataState, setItemFilter]
  );

  return (
    <DropDownList
      id="shopping-list-item-filter-dropdown"
      className="k-picker-solid product-filter-dropdown"
      style={{ width: 200 }}
      data={translatedFilterCategories}
      textField="label"
      dataItemKey="value"
      value={translatedValue}
      onChange={handleItemFilterChange}
      popupSettings={{ className: 'toolbar-dropdown-popup' }}
    />
  );
};

export default ShoppingListItemFilterDropdown;
